import variantService from '../../../services/variantService';

/**
 * Variant Controller
 * Handles all variant-related API calls and data transformations
 */
const VariantController = {
  /**
   * Fetch variants with optional filtering and pagination
   * @param {number} page - Current page number
   * @param {number} pageSize - Items per page
   * @param {string} searchTerm - Optional search filter
   * @returns {Promise<Object>} - Paginated variant data
   */
  fetchVariants: async (page = 1, pageSize = 10, searchTerm = '') => {
    try {
      // Use the service to make the API call with all parameters
      const token = localStorage.getItem('authToken');
      const response = await variantService.getVariants(page, pageSize, searchTerm, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      return response;
    } catch (error) {
      console.error('Error fetching variants:', error);
      throw error;
    }
  },

  fetchAllVariants: async (searchTerm = '') => {
    try {
      const token = localStorage.getItem('authToken');
      // Use the service to make the API call with all parameters
      const response = await variantService.getAllVariants({}, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      return response;
    } catch (error) {
      console.error('Error fetching variants:', error);
      throw error;
    }
  },
  
  /**
   * Create a new variant with values
   * @param {Object} variantData - Contains name and values array
   * @returns {Promise<Object>} - Created variant data
   */
  createVariant: async (variantData) => {
    try {
      const token = localStorage.getItem('authToken');
      // Using the service to make the API call
      const response = await variantService.createVariant({
        name: variantData.name,
        values: variantData.values
      }, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      
      return response;
    } catch (error) {
      console.error('Error creating variant:', error);
      throw error;
    }
  },
  
  /**
   * Update an existing variant
   * @param {Object} variantData - Updated variant data
   * @returns {Promise<Object>} - Updated variant data
   */
  updateVariant: async (variantData) => {
    try {
      return await variantService.updateVariant(variantData.id, variantData);
    } catch (error) {
      console.error(`Error updating variant #${variantData.id}:`, error);
      throw error;
    }
  },
  
  /**
   * Delete a variant
   * @param {number} variantId - ID of variant to delete
   * @returns {Promise<boolean>} - Success indicator
   */
  deleteVariant: async (variantId) => {
    try {
      const token = localStorage.getItem('authToken');
      // Using the service to make the API call
      await variantService.deleteVariant(variantId, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      return true;
    } catch (error) {
      console.error(`Error deleting variant #${variantId}:`, error);
      throw error;
    }
  },
  
  /**
   * Add a new value to a variant
   * @param {number} variantId - Parent variant ID
   * @param {string} value - Value to add
   * @returns {Promise<Object>} - Created variant value
   */
  addVariantValue: async (variantId, value) => {
    try {
      const token = localStorage.getItem('authToken');
      // Using the service to make the API call
      return await variantService.values.addValue(variantId, value, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
    } catch (error) {
      console.error(`Error adding value to variant #${variantId}:`, error);
      throw error;
    }
  },
  
  /**
   * Update a variant value
   * @param {number} variantId - Parent variant ID
   * @param {number} valueId - ID of value to update
   * @param {string} newValue - New value content
   * @returns {Promise<Object>} - Updated variant value
   */
  updateVariantValue: async (variantId, valueId, newValue) => {
    try {
      const token = localStorage.getItem('authToken');
      console.log('this is the newValue', newValue);
      return await variantService.values.updateValue(variantId, valueId, { value: newValue }, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
    } catch (error) {
      console.error(`Error updating value #${valueId}:`, error);
      throw error;
    }
  },
  
  /**
   * Delete a variant value
   * @param {number} variantId - Parent variant ID
   * @param {number} valueId - ID of value to delete
   * @returns {Promise<boolean>} - Success indicator
   */
  deleteVariantValue: async (variantId, valueId) => {
    try {
      const token = localStorage.getItem('authToken');
      // Using the service to make the API call
      await variantService.values.deleteValue(variantId, valueId, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      return true;
    } catch (error) {
      console.error(`Error deleting value #${valueId}:`, error);
      throw error;
    }
  }
};

export default VariantController;
